import { createAsyncThunk } from '@reduxjs/toolkit';

// Thunks only: a URL's extras are kept by the panel that asked for them, not in
// the store.

export const refreshUrl = createAsyncThunk(
  'urls/refreshUrl',
  async ({ urlId, ai }, { extra }) => {
    const { urlsApi } = extra;
    return urlsApi.refreshUrl(urlId, { ai });
  },
);

export const addUrlPost = createAsyncThunk(
  'urls/addUrlPost',
  async ({ urlId, post }, { extra }) => {
    const { urlsApi } = extra;
    return urlsApi.addPost(urlId, post);
  },
);

export const updateUrlPost = createAsyncThunk(
  'urls/updateUrlPost',
  async ({
    urlId, source, postId, patch,
  }, { extra }) => {
    const { urlsApi } = extra;
    return urlsApi.updatePost(urlId, source, postId, patch);
  },
);

export const removeUrlPost = createAsyncThunk(
  'urls/removeUrlPost',
  async ({ urlId, source, postId }, { extra }) => {
    const { urlsApi } = extra;
    return urlsApi.removePost(urlId, source, postId);
  },
);

export const refreshUrlPosts = createAsyncThunk(
  'urls/refreshUrlPosts',
  async ({ urlId, source, postId }, { extra }) => {
    const { urlsApi } = extra;
    return urlsApi.refreshPosts(urlId, source, postId);
  },
);
